import { IconButton, Input, Popover, Portal } from '@lego/klik-ui';
import { Filter, FilterBold } from '@lego/klik-ui/icons';
import type { RowData } from '@tanstack/react-table';
import type { Column } from '../appTable';

export const SingleSearchFilter = <T extends RowData>({ column }: { column: Column<T> }) => {
  const meta = column.columnDef.meta?.filterVariant;
  const constraint = meta?.type === 'singleSearch' ? meta.constraint : undefined;

  const columnFilterValue = (column.getFilterValue() as string) ?? '';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (constraint && !constraint.test(value)) return;
    column.setFilterValue(value || undefined);
  };

  return (
    <Popover autoFocus closeOnBlur isLazy placement="top">
      <Popover.Trigger>
        {!column.getIsFiltered() ? (
          <IconButton aria-label="Menu" icon={<Filter />} size="xs" variant="ghost" />
        ) : (
          <IconButton aria-label="Menu" icon={<FilterBold />} size="xs" variant="ghost" />
        )}
      </Popover.Trigger>
      <Portal>
        <Popover.Content p={0}>
          <Popover.Arrow />
          <Popover.Body p={2}>
            <Input
              autoFocus
              inputMode={constraint ? 'numeric' : 'text'}
              onChange={handleChange}
              placeholder="Start typing..."
              size="sm"
              value={columnFilterValue}
            />
          </Popover.Body>
        </Popover.Content>
      </Portal>
    </Popover>
  );
};
